import { useLayoutEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

const positions = new Map<string, number>()
/** Restore the source list after detail → management → return, including delayed data. */
export function useListScroll(userId?: string) {
  const ref = useRef<HTMLElement>(null)
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  for (const key of ['orderDetail', 'orderRole', 'orderMode']) params.delete(key)
  const key = `${userId || ''}:${location.pathname}?${params}`
  useLayoutEffect(() => {
    const node = ref.current
    if (!node) return
    const saved = positions.get(key) || 0
    let restoring = true
    const restore = () => {
      if (!restoring) return
      node.scrollTop = saved
      if (node.scrollTop >= saved) restoring = false
    }
    const stop = () => { restoring = false }
    const remember = () => {
      if (!restoring) positions.set(key, node.scrollTop)
      if (positions.size > 50) positions.delete(positions.keys().next().value!)
    }
    const observer = new ResizeObserver(restore)
    if (node.firstElementChild) observer.observe(node.firstElementChild)
    restore()
    node.addEventListener('scroll', remember)
    node.addEventListener('wheel', stop, {passive:true})
    node.addEventListener('touchstart', stop, {passive:true})
    return () => {
      observer.disconnect()
      node.removeEventListener('scroll', remember)
      node.removeEventListener('wheel', stop)
      node.removeEventListener('touchstart', stop)
    }
  }, [key])
  return ref
}
